<template>
  <label
      :class="classObject()"
  >
    <input
        class="preview__radio"
        type="radio"
        :id="card.action"
        :class="card.input_class"
        :value="card.action"
        :name="radioName"
        v-model="radioButtonValue"
    />
    <span
        v-if="isActive"
        class="preview__check icon"
    >
      <check-svg/>
    </span>
    <span class="preview__thumb">
      <img
          :src="filename"
          :alt="card.name"
          @error="onImgError()"
      />
    </span>
    <span class="preview__name">{{ card.name }}</span>
  </label>
</template>

<script>
import CheckSvg from '../../../../../assets/img/icons/check.svg';

export default {
  name: 'previewCard',
  components: {
    CheckSvg,
  },
  props: {
    card: Object,
    isActive: Boolean,
    material: Boolean,
    dropdownId: String,
  },
  data() {
    return {
      imgError: false,
    }
  },
  computed: {
    radioName() {
      return this.card.action_id;
    },
    filename() {
      return (this.imgError) ? this.placeholder : this.card.thumb;
    },
    placeholder() {
      return this.$store.state.siteData.global.placeholder_image;
    },
    radioButtonValue: {
      get() {
        return this.actionName[this.card.action_id];
      },
      set() {
        this.$store.commit('changeActionName', {
          payload: this.card.action,
          target: this.card.action_id,
        });
        if (this.card.action.includes('hb:mtl')) {
          this.$store.commit('checkedFabric', this.card.name);
        }

        this.$emit('checked', this.card.name);
      },
    },
    actionName() {
      return this.$store.state.selectedActionName;
    },
    fabric() {
      return this.$store.state.fabric;
    },
  },
  mounted() {
    if (this.card.selected === 'selected') {
      this.$store.commit('updateLoadProduct',
          this.card.action.split('=').pop());
    }
  },
  methods: {
    classObject() {
      return {
        'preview': true,
        'preview--material': this.material,
        'is-active': this.isActive
      };
    },
    onImgError() {
      this.imgError = true;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/setup.scss';

.preview {
  $this: &;

  position: relative;
  width: 100%;
  min-width: 0;
  display: block;
  opacity: 0.5;
  cursor: pointer;
  @include anim();

  @include hover {
    opacity: 1;
  }

  &.is-active {
    opacity: 1;
  }

  span {
    display: block;

    &#{$this}__thumb {
      display: flex;
    }
  }

  &__radio {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  &__check {
    position: absolute;
    top: -15px;
    right: -9.85px;
    z-index: 1;
  }

  &__thumb {
    position: relative;
    margin-bottom: 9px;
    width: 100%;
    height: 18.13vw;

    @include up-tablet {
      height: 8.85vw;
    }

    @include up-laptop {
      height: 4.72vw;
    }

    .touch & {
      @media (min-width: 1024px) and (orientation: landscape) {
        height: 4.72vw;
      }

      @include up-laptop {
        height: 4.72vw;
      }
    }

    .preview--material & {
      height: 11.7333vw;

      @include up-tablet {
        height: 5.7291vw;
      }

      @include up-laptop {
        height: 3.0556vw;
      }

      .touch & {
        @media (min-width: 1024px) and (orientation: landscape) {
          height: 3.0556vw;
        }

        @include up-laptop {
          height: 3.0556vw;
        }
      }
    }

    img {
      width: 100%;
      height: auto;
      max-height: 100%;
      object-fit: contain;

      .preview--material & {
        object-fit: cover;
      }
    }
  }

  &__name {
    font-family: $f-bellReg;
    font-size: 13px;
    line-height: 15px;
    text-transform: capitalize;
  }
}
</style>
